import React from 'react';
import PropTypes from 'prop-types';
import GetPremiumButton from './GetPremiumButton';

function PremiumTitle({ translate, isPremiumUser }) {
  return (
    <div className='premium-title-section dark-theme center-container' id='premium-title'>
      <div className='premium-logo-container center-item'>
        <div className='icon-premium-120x120' />
        <div className='font-title premium-tagline'>{translate('Heading.RobloxPremium')}</div>
        {!isPremiumUser && <GetPremiumButton translate={translate} />}
      </div>
    </div>
  );
}

PremiumTitle.propTypes = {
  translate: PropTypes.func.isRequired,
  isPremiumUser: PropTypes.bool.isRequired
};

export default PremiumTitle;
